export const POSITION_ALL_VALUE = 'all' as const;

export const POSITION_ALL_LABEL = 'Все профессии';

export const SIZ_TAB_KEYS = {
  norms: 'norms',
  issuance: 'issuance',
  procurement: 'procurement',
} as const;

export type SizTabKey = (typeof SIZ_TAB_KEYS)[keyof typeof SIZ_TAB_KEYS];

export const SIZ_TAB_ITEMS: { key: SizTabKey; label: string }[] = [
  { key: SIZ_TAB_KEYS.norms, label: 'Справочник норм' },
  { key: SIZ_TAB_KEYS.issuance, label: 'Учёт выдачи' },
  { key: SIZ_TAB_KEYS.procurement, label: 'Ведомости и потребность' },
];

export const NORMS_CARD_TITLE = 'Справочник норм СИЗ';

export const NORMS_ADD_BUTTON = '+ Норма';

/** Общий текстовый поиск по строке нормы (профессия, СИЗ, норма, период). */
export const NORMS_FREE_SEARCH_PLACEHOLDER = 'Поиск: профессия, норма, период...';

export const NORMS_PPE_NAME_PLACEHOLDER = 'Наименование СИЗ';

export const NORMS_PROFESSION_FILTER_PLACEHOLDER = 'Группа профессии (ЕТКС)';

export const NORMS_RANK_FILTER_PLACEHOLDER = 'Разряд (ЕТКС)';

export const NORMS_CONDITION_CLASS_PLACEHOLDER = 'Класс условий труда (СОУТ)';

export const HISTORY_COLLAPSE_LABEL = (count: number) => `История изменений норм (${count})`;

export const HISTORY_EMPTY_TEXT = 'Нет записей. Добавьте норму или зафиксируйте выдачу.';

export const NORM_MODAL_TITLE = 'Новая норма СИЗ';

export const NORM_MODAL_OK = 'Сохранить';

export const NORM_SUCCESS_MESSAGE = 'Норма добавлена';

export const ISSUANCE_CARD_TITLE = 'Фактическая выдача СИЗ';

export const ISSUANCE_ADD_BUTTON = '+ Выдать СИЗ';

export const ISSUANCE_MODAL_TITLE = 'Фиксация выдачи СИЗ';

export const ISSUANCE_MODAL_OK = 'Зафиксировать';

export const ISSUANCE_SUCCESS_MESSAGE = 'Выдача СИЗ зафиксирована';

export const ISSUANCE_EXPORT = {
  pdfTitle: 'Ведомость выдачи СИЗ',
  pdfSlug: 'Ведомость_выдачи_СИЗ',
  csvFilename: 'Ведомость_выдачи_СИЗ_Р7.csv',
  csvHeader: 'Сотрудник;Наименование СИЗ;Кол-во;Дата выдачи;Годен до;Срок службы',
  pdfHead: ['#', 'Сотрудник', 'Наименование СИЗ', 'Кол-во', 'Дата выдачи', 'Годен до', 'Срок службы'],
} as const;

export const PROCUREMENT_CARD_TITLE = 'Потребность в закупке СИЗ';

export const PROCUREMENT_DEFICIT_TAG = (total: number) => `Дефицит: ${total}`;

export const PROCUREMENT_EXPORT = {
  pdfTitle: 'Потребность в закупке СИЗ',
  pdfSlug: 'Потребность_в_СИЗ',
  csvFilename: 'Потребность_в_СИЗ_Р7.csv',
  csvHeader: 'Профессия;СИЗ;Норма;Период;Сотрудников;Потребность;Выдано;Дефицит',
  pdfHead: ['#', 'Профессия', 'СИЗ', 'Норма', 'Период', 'Сотр.', 'Потребность', 'Выдано', 'Дефицит'],
} as const;

export const PDF_SUCCESS_MESSAGE = 'PDF сохранён';

export const PDF_ERROR_MESSAGE = 'Не удалось сформировать PDF';

export const CSV_SUCCESS_MESSAGE = 'Файл для Р7 (CSV) сохранён';

export const EXPORT_PDF_LABEL = 'PDF';

export const EXPORT_R7_LABEL = 'Р7';
